module.exports = __webpack_public_path__ + "files/4bda3ff18a93f65351133dd24bfc0af2.png";